import React, { useState, useEffect, useRef } from "react";
import { Form, Button } from "react-bootstrap";
import CompProfileTabs from "./CompProfileTabs";
import "./CompProfile.css";
import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
import * as FeatherIcon from "react-feather";
import { Link } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import AIChat from "../Chat/AiChat";
import { useParams } from "react-router-dom";
import iq_download from "../../../services/iqDownload";
import api from "../../../services/api";
import { exportRequest } from "../../../services/accIqService";
import { useWebSocket } from "../uiUtils/useWebSocket";
import ProgressOverlay from "../../HtmlElements/ProgressOverlay";
import { API_BASE_URL } from "../../../config/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../../hooks/useAuth";
import UpdateCompProfileDimensions from "./UpdateCompProfileDimensions";
import APP_CONFIG from "../../../config/appConfig";
import { createSuggestedCompetitorRequest } from "../../../store/features/actions/suggestedCompetitorActions";
import { fetchExistingSubdimensionsRequest } from "../../../store/features/actions/fetchExistingSubdimensionsActions";
import { useCompetitorContext } from "../../../context/CompetitorContext";
import Alert from "../../HtmlElements/Alert";
import {
  getTaggedKsCompanies,
  getVendorCompanyId,
} from "../../../services/commonService";
import { updateCompetitorProfileRequest } from "../../../store/features/actions/updateCompetitorProfileActions";
import CompetitorAiTableModal from "./CompetitorTabs/AiTableBuilder/CompetitorAiTableModal";
import { Scroll } from "lucide-react";

export default function CompProfile() {
  useAuth();
  const dispatch = useDispatch();
  const { competitorInfo } = useCompetitorContext();
  const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];
  const account_manger_role = ["ROLE_ACCOUNT_MANAGER"];
  const vendorCompanyIdGlobal = getVendorCompanyId(competitorInfo);
  const taggedKsCompanies = getTaggedKsCompanies(competitorInfo);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [showAiInsights, setShowAiInsights] = useState(false);
  const [activeParentTabKey, setParentActiveTab] = useState("executiveSnap");
  const [compView, setCompetitorView] = useState("complete");
  const [sidecardTitleBlock, setSidecardTitleBlock] = useState([]);
  const [showAiBuilder, setShowAiBuilder] = useState(false);
  const [aiBuilderDimensionOptions, setAiBuilderDimensionOptions] = useState(
    []
  );
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [
    displayCompProfileUpdatesSection,
    setDisplayCompProfileUpdatesSection,
  ] = useState(false);
  const wsRef = useRef(null);
  const [wsUrl, setWsUrl] = useState(null);
  const tabTypeMap = {
    executiveSnap: "Executive Snapshot",
    profileMarketPosition: "Market Position & Customer Intelligence",
    profileProductInnovation: "Product & Innovation",
    financials: "Financial Performance & Strategy",
    marketing: "Marketing & Distribution",
    operations: "Operations & Supply Chain",
    orgStructure: "Corporate & Organizational Structure",
    news: "News",
  };

  const { user } = useUser();
  const { clientName, competitorName } = useParams();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const POLLING_INTERVAL_MS = 5000; // 5 sec
  // const POLLING_INTERVAL_MS = 600000; // 10 minutes

  // +++++++++++++++++++++++++++++++
  const [showProgress, setShowProgress] = useState(false);
  const [taskCompleted, setTaskCompleted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setTaskCompleted(true), 480000);
    return () => clearTimeout(timer);
  }, []);
  // +++++++++++++++++++++++++++++++

  // +++++++++++++++++++++++++++++++
  const { creating, success } = useSelector(
    (state) => state.updateCompetitorProfileReducer
  );
  // +++++++++++++++++++++++++++++++

  // ++++++++++++++++++++++++++++++++++++++
  const dummyExistingSubdimensions = [
    "Business Segment",
    "GTM & Distribution Strategy Analysis",
  ];
  // const [useExistingSubdimensionApi, setUseExistingSubdimensionApi] =
  //   useState(false);
  const [useExistingSubdimensionApi, setUseExistingSubdimensionApi] =
    useState(true);
  const [existingSubdimensions, setExistingSubdimensions] = useState([]);
  const { loadingDimensions, data, error } = useSelector(
    (state) => state.fetchExistingSubdimensionsReducer
  );

  useEffect(() => {
    if (data) {
      setExistingSubdimensions(data);
    }
  }, [data]);
  // ++++++++++++++++++++++++++++++++++++++

  const downloadFileAsBlob = async (taskId, filename, downloadUrl) => {
    try {
      // const resp = await iq_download.get(`api/pdf/downloads/${taskId}.pdf`, {
      //   responseType: "blob",
      // });
      const resp = await iq_download.get(`${downloadUrl}`, {
        responseType: "blob",
      });

      // Check if response status is OK
      if (!resp.status || resp.status !== 200) {
        throw new Error(`Download failed: ${resp.status} ${resp.statusText}`);
      }

      const blob = resp.data;
      const objectUrl = URL.createObjectURL(blob);

      const timestamp = new Date().toISOString().replace(/[^\w]/g, "_");
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = `Competitor Profile For ${competitorName}_${timestamp}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
      setTaskCompleted(false);
      setShowProgress(false);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  // const pollTaskStatus = async (taskId) => {
  //   setStatus("Polling export status...");
  //   setShowProgress(true);
  //   const intervalId = setInterval(async () => {
  //     try {
  //       const res = await iq_download.get(`/api/pdf/export-status/${taskId}`);

  //       if (!res) {
  //         setStatus(`Error: ${res.status} ${res.statusText}`);
  //         clearInterval(intervalId);
  //         return;
  //       }

  //       // const data = await res.json();
  //       const data = res.data;
  //       console.log("Polling status:", data);
  //       setStatus(`Current status: ${data.status}`);

  //       if (data?.status === "COMPLETE" && data?.pdf_url) {
  //         clearInterval(intervalId);
  //         setStatus("Export complete! Downloading PDF...");

  //         const downloadUrl = `${data.pdf_url}`;
  //         // console.log("COM URL: " + downloadUrl);
  //         const filename = data.pdf_url.split("/").pop();

  //         try {
  //           await downloadFileAsBlob(taskId, filename);
  //           setStatus("Download started (check your downloads folder).");
  //         } catch (err) {
  //           console.error("Download error:", err);
  //           setStatus("Download failed.");
  //         }
  //       } else if (data.status === "FAILED") {
  //         clearInterval(intervalId);
  //         setStatus("Export task failed.");
  //         console.error("Task failed:", data);
  //       }
  //     } catch (err) {
  //       console.error("Polling error:", err);
  //       setStatus("Polling connection failed.");
  //       clearInterval(intervalId);
  //     }
  //   }, POLLING_INTERVAL_MS);
  // };

  const pollTaskStatus = async (taskId, userId, projectId) => {
    let isUserActive = true;
    let intervalId = null;
    setShowProgress(true);
    // Track user activity / tab visibility
    const handleVisibilityChange = () => {
      isUserActive = !document.hidden;
    };

    // const handleBeforeUnload = () => {
    //   isUserActive = false;
    //   // Optional: tell backend user left
    //   navigator.sendBeacon(
    //     "/api/user_inactive",
    //     JSON.stringify({ userId, projectId })
    //   );
    // };

    const handleBeforeUnload = () => {
      isUserActive = false;

      const payload = {
        client_name: clientName,
        competitor_name: competitorName,
        user_id: user?.id,
        pdf_url: `https://growthiq.mnmks.com//growth_iq_download_proxy/api/pdf/${taskId}.pdf`,
        task_id: taskId,
      };

      const blob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
      });

      // Use the absolute backend API URL (bypassing interceptors)
      navigator.sendBeacon(`${API_BASE_URL}/export/email_download_link`, blob);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    setStatus("Polling export status...");
    setShowProgress(true);

    intervalId = setInterval(async () => {
      try {
        const res = await iq_download.get(`/api/pdf/export-status/${taskId}`);
        if (!res) {
          setStatus(`Error: ${res.status} ${res.statusText}`);
          clearInterval(intervalId);
          return;
        }

        const data = res.data;
        console.log("Polling status:", data);
        setStatus(`Current status: ${data.status}`);

        if (data?.status === "COMPLETE" && data?.pdf_url) {
          clearInterval(intervalId);
          document.removeEventListener(
            "visibilitychange",
            handleVisibilityChange
          );
          window.removeEventListener("beforeunload", handleBeforeUnload);

          // const downloadUrl = `https://growthiq.mnmks.com//growth_iq_download_proxy${data.pdf_url}`;
          const downloadUrl = data.pdf_url;
          const filename = data.pdf_url.split("/").pop();
          if (isUserActive) {
            // User still here → download file
            setStatus("Export complete! Downloading PDF...");
            try {
              await downloadFileAsBlob(taskId, filename, downloadUrl);
              setStatus("Download started (check your downloads folder).");
            } catch (err) {
              console.error("Download error:", err);
              setStatus("Download failed.");
            }
          } else {
            // User left → send email
            console.log("User inactive — sending email...");
            setStatus("User left, sending download link to email...");
            await api.post(`/export/email_download_link`, {
              client_name: clientName,
              competitor_name: competitorName,
              user_id: user?.id,
              pdf_url: downloadUrl,
              task_id: taskId,
            });
          }
        } else if (data.status === "FAILED") {
          clearInterval(intervalId);
          setStatus("Export task failed.");
          console.error("Task failed:", data);
        }
      } catch (err) {
        console.error("Polling error:", err);
        setStatus("Polling connection failed.");
        clearInterval(intervalId);
      }
    }, POLLING_INTERVAL_MS);
  };

  const exportAll = async () => {
    const downloadRequestData = {
      client: clientName,
      competitor: competitorName,
    };
    try {
      const res = await exportRequest(downloadRequestData);
      // console.log("Download request response:", res);
      const taskId = res?.task_id;

      if (!taskId) {
        setStatus("Failed: No task_id returned from export API.");
        setLoading(false);
        return;
      }

      setStatus(`Export task started (Task ID: ${taskId})`);
      // Start polling the status
      await pollTaskStatus(taskId);
    } catch (err) {
      console.error("Export request error:", err);
      setStatus("Export request failed.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!competitorName) return;

    if (useExistingSubdimensionApi) {
      dispatch(
        fetchExistingSubdimensionsRequest({
          user_id: user?.user_id,
          user_role: user?.growth_iq_role_name,
          client: clientName,
          competitor_name: competitorName,
        })
      );
    } else {
      // console.log("Using dummy subdimensions (API disabled)");
    }
  }, [competitorName, user?.user_id, useExistingSubdimensionApi]);

  useEffect(() => {
    let titleBlock = "";

    titleBlock = (
      <div className="mem-sc-titl-cont justify-content-between">
        <div className="top_head_side_block">
          <div
            className="side_intial_block"
            style={{ backgroundColor: "#7879F1" }}
          >
            <p className="side_intial">A</p>
          </div>
          <div className="top_side_guide">
            <h5 className="top_head_side_guide">Current Profile</h5>
            <span className="span_memory">Update Competitor Profile</span>
          </div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            setShowMoreModal(false);
          }}
        ></button>
      </div>
    );
    setSidecardTitleBlock(titleBlock);

    if (showMoreModal) {
      // setExistingSubdimensions(dummyExistingSubdimensions);
      const currentProfileSubdimensions = useExistingSubdimensionApi
        ? data
        : dummyExistingSubdimensions;
      // console.log("Current Profile Subdimensions:", data?.data);
      setExistingSubdimensions(currentProfileSubdimensions);
    }
  }, [showMoreModal]);

  const handleUpdateCompProfile = async (data) => {
    const payload = {
      user_id: user?.user_id,
      user_role: user?.growth_iq_role_name,
      user_type:
        user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
      client: clientName,
      competitor: competitorName,
      company_id: vendorCompanyIdGlobal,
      subdimensions: data?.selected_subdimensions,
      ksCompanies: taggedKsCompanies,
      industry: user?.industry,
      remove_subdimensions: data?.removed_subdimensions,
    };

    dispatch(updateCompetitorProfileRequest(payload));
  };

  useEffect(() => {
    if (success) {
      setSuccessMessage(
        "Competitor profile update request submitted successfully!"
      );
      setTimeout(() => {
        setSuccessMessage("");
        setShowMoreModal(false);
      }, 5000);
    }
  }, [creating, success]);

  //  Cleanup WebSocket when component unmounts
  useEffect(() => {
    return () => {
      if (wsRef.current) wsRef.current.close();
    };
  }, []);

  const handleCompViewChange = (competitorView = "complete") => {
    setCompetitorView(competitorView);
  };

  // Name to be displayed in comp profile header
  const displayName =
    competitorInfo?.competitor_display_name ||
    competitorInfo?.competitor_name ||
    competitorName;

  return (
    <div>
      {/* ++++++++++++++++++++++++++ */}
      {/* 20 * 60 * 1000 => 20 minutes */}
      {showProgress && (
        <ProgressOverlay
          title="Processing your export"
          linkText={`Competitor profile for ${competitorName}`}
          totalTime={10 * 60 * 1000}
          taskCompleted={taskCompleted}
          onClose={() => setShowProgress(false)}
        />
      )}
      {/* ++++++++++++++++++++++++++ */}
      <div className="account_details_wrapper">
        <div className="cardinal_wrapper">
          <div className="back_to_block mb-4">
            <Link to="/clients_competitors" className="back_to_text_comp">
              <FeatherIcon.ArrowLeft className="back_icon" /> Back to
              Competitors
            </Link>
          </div>
          <div className="cardinal_head_block">
            <div className="cardinal_subblock">
              <h5 className="cardinal_head">
                Competitor Profile – {displayName}
              </h5>
            </div>

            <div className="cardinal_btns">
              {/* <div className="toggle_list_tableview">
                <Link
                  className={`table_view ${
                    compView === "complete" ? "active" : ""
                  }`}
                  style={{
                    fontSize: "12px",
                    lineHeight: "15px",
                    textDecoration: "none",
                    padding: "7px 12px 7px 12px",
                    // width: "56px",
                    // height: "27px",
                    radius: "8px",
                  }}
                  onClick={() => handleCompViewChange("complete")}
                >
                  Complete
                </Link>
                <Link
                  className={`grid_view ${
                    compView === "quantitative" ? "active" : ""
                  }`}
                  style={{
                    fontSize: "12px",
                    lineHeight: "15px",
                    textDecoration: "none",
                    padding: "7px 12px 7px 12px",
                    // width: "56px",
                    // height: "27px",
                    radius: "8px",
                  }}
                  onClick={() => handleCompViewChange("quantitative")}
                >
                  Quantitative
                </Link>
              </div> */}

              {!account_manger_role.includes(user?.growth_iq_role_name) && (
                <a
                  href="#"
                  className="cardninal_href"
                  onClick={() =>
                    setDisplayCompProfileUpdatesSection((prev) => !prev)
                  }
                >
                  New Updates
                </a>
              )}
              {/* <span className="count_update">15</span> */}
              {/* <div className="export-wrapper" style={{ position: "relative" }}>
                <a
                  href="#"
                  className="cardninal_href"
                  onClick={exportAll}
                  disabled={loading}
                >
                  Export{" "}
                  <img
                    src="/img/export_arrow.png"
                    alt="image"
                    className="cardinal_filter_img"
                    width=""
                  />
                </a>
              </div> */}

              {/* <a href="#" className="cardninal_href">
                Notify My Team{" "}
                <img
                  src="/img/noitfy_my_team.png"
                  alt="image"
                  className="cardinal_filter_img"
                  width=""
                />
              </a> */}
              {/* <a
                href="#"
                className="cardninal_href"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowAiInsights(true);
                }}
              >
                {" "}
                <img
                  src="/img/ai_sparkle.png"
                  alt="image"
                  className="cardinal_filter_img mr-1"
                  width=""
                />{" "}
                AI Insight
              </a> */}
              {
                // !account_manger_role.includes(user?.growth_iq_role_name) &&
                <Link
                  variant="dark"
                  className="new_benchmark max_height_30 update_comp_profile_btn"
                  // to={"/benchmarks/" + company_id + "/" + clientName}
                  to={"/benchmarks/default/" + clientName}
                  style={{ textDecoration: "none" }}
                >
                  {" "}
                  {/* <img
                    src="/img/plus.png"
                    alt="image"
                    className="filter_image mr-1"
                    width="16"
                  />{" "} */}
                  View Benchmark
                </Link>
              }

              {!account_manger_role.includes(user?.growth_iq_role_name) && (
                <Button
                  variant="dark"
                  className="new_benchmark max_height_30 update_comp_profile_btn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowAiBuilder(true);
                  }}
                >
                  {" "}
                  <img
                    src="/img/plus.png"
                    alt="image"
                    className="filter_image mr-1"
                    width="16"
                  />{" "}
                  Add Section
                </Button>
              )}

              {!account_manger_role.includes(user?.growth_iq_role_name) && (
                <Button
                  variant="dark"
                  className="new_benchmark max_height_30 update_comp_profile_btn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowMoreModal(true);
                  }}
                >
                  {" "}
                  <img
                    src="/img/plus.png"
                    alt="image"
                    className="filter_image mr-1"
                    width="16"
                  />{" "}
                  Update Comp Profile
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="top_tabs_custom">
          <CompProfileTabs
            displayCompProfileUpdatesSection={displayCompProfileUpdatesSection}
            activeParentTabKey={activeParentTabKey}
            setParentActiveTab={setParentActiveTab}
            compView={compView}
            existingSubdimensions={existingSubdimensions}
            setAiBuilderDimensionOptions={setAiBuilderDimensionOptions}
          />
        </div>
      </div>

      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={sidecardTitleBlock}
        // comp={<></>}
        comp={
          <>
            {successMessage && (
              <Alert type="success" message={successMessage} />
            )}
            <UpdateCompProfileDimensions
              existingSubdimensions={existingSubdimensions}
              onSubmit={handleUpdateCompProfile}
              onCancel={() => setShowMoreModal(false)}
            />
          </>
        }
        minWidthForDrawer="50%"
        disableXbtn={true}
      />

      <GenericOverviewSideCard
        showMoreModal={showAiInsights}
        setShowMoreModal={setShowAiInsights}
        titleForSideCard={
          <div className="ai_insight_top_block">
            <div className="ai_insight_left">
              <div className="ai_insight_img">
                <img
                  src="/img/ai_insight_top.png"
                  alt="icon"
                  className="ai_icon"
                />
              </div>
              <div className="ai_insight_text">
                <h5 className="ai_insight_top_head">
                  Decode This: {competitorName}
                  {" - "}
                  {tabTypeMap[activeParentTabKey]}
                </h5>
                <p className="ai_insight_top_subhead">
                  AI-powered competitive intelligence and strategic insights
                </p>
              </div>
            </div>
            <div className="ai_insight_right"></div>
          </div>
        }
        comp={<AIChat />}
        minWidthForDrawer="50%"
        disableXbtn={false}
      />

      <CompetitorAiTableModal
        user_id={user?.user_id}
        user_role={user?.growth_iq_role_name}
        client={clientName}
        competitor={competitorName}
        showAiBuilder={showAiBuilder}
        setShowAiBuilder={setShowAiBuilder}
        aiBuilderDimensionOptions={aiBuilderDimensionOptions}
      />
    </div>
  );
}
